<section class="py-2 px-4 text-center">
	<div class="max-w-auto md:max-w-lg mx-auto">
		<p class="flex justify-center space-x-2 font-black my-8">
			Stratagems is an independent universe forever running where players strategicaly place colors on an infinite grid
			using ETH with the hope to collect more of it from the other players. Alliances and betrayal are part of the
			arsenal as the colors mix and shift.
		</p>
	</div>

	<div class="pt-3 pb-4">
		<p class="mt-6 text-base-300">
			Find out more on
			<a class="underline" href="https://stratagems.world" target="_blank" rel="noreferrer">our website</a> or on
			<a class="underline" href="https://github.com/wighawag/stratagems#readme" target="_blank" rel="noreferrer"
				>github</a
			>
		</p>
	</div>
</section>
